export const GET_SEASON = "GET_SEASON"
export const GET_SEASON_SUCCESS = "GET_SEASON_SUCCESS"
export const GET_ERROR = "GET_ERROR"
